<!-- Not found -->
<div class="pub-shell" *ngIf="notFound">
  <div class="not-found">
    <span class="material-symbols-outlined">search_off</span>
    <h2>Profesional no encontrado</h2>
    <p>El link de reserva no es válido o fue desactivado.</p>
  </div>
</div>

<div class="pub-shell" *ngIf="!notFound && professional">

  <!-- Prof header -->
  <header class="prof-header animate-fade-in">
    <div class="prof-avatar">
      <span class="material-symbols-outlined">person</span>
    </div>
    <div class="prof-header__info">
      <h1>{{ professional.name }}</h1>
      <p *ngIf="professional.specialty">{{ professional.specialty }}</p>
      <div class="prof-meta">
        <span class="prof-badge">
          <span class="material-symbols-outlined">verified</span>
          Profesional verificado
        </span>
        <button class="copy-link-btn" (click)="copyLink()">
          <span class="material-symbols-outlined">link</span>
          Copiar link
        </button>
      </div>
    </div>
  </header>

  <!-- ═══ STEP 1: Selección ═══ -->
  <div *ngIf="step === 'select'" class="pub-content animate-fade-in">

    <!-- Servicio -->
    <section class="pub-section stagger-1">
      <h2 class="pub-section__label">
        <span class="material-symbols-outlined">medical_services</span>
        Tipo de servicio
      </h2>
      <div class="service-grid">
        <button
          *ngFor="let svc of serviceTypes"
          class="service-card"
          [class.service-card--selected]="selectedService.label === svc.label"
          (click)="selectService(svc)"
        >
          <span class="service-card__name">{{ svc.label }}</span>
          <span class="service-card__duration">{{ svc.duration }} min</span>
        </button>
      </div>
    </section>

    <!-- Fecha -->
    <section class="pub-section stagger-2">
      <h2 class="pub-section__label">
        <span class="material-symbols-outlined">calendar_month</span>
        Fecha
      </h2>
      <div class="date-scroll">
        <button
          *ngFor="let d of availableDates"
          class="date-chip"
          [class.date-chip--selected]="selectedDate === d"
          (click)="selectDate(d)"
        >
          {{ formatDate(d) }}
        </button>
      </div>
    </section>

    <!-- Horarios -->
    <section class="pub-section stagger-3" *ngIf="selectedDate">
      <h2 class="pub-section__label">
        <span class="material-symbols-outlined">schedule</span>
        Horario disponible
        <span class="pub-section__date">{{ formatDateFull(selectedDate) }}</span>
      </h2>
      <div class="slots-grid">
        <button
          *ngFor="let slot of timeSlots"
          class="slot-btn"
          [class.slot-btn--selected]="selectedTime === slot.time"
          [class.slot-btn--taken]="!slot.available"
          [disabled]="!slot.available"
          (click)="selectTime(slot)"
        >
          {{ slot.time }}
          <span *ngIf="!slot.available" class="slot-taken">Ocupado</span>
        </button>
      </div>
    </section>

    <!-- CTA -->
    <div class="pub-cta stagger-4">
      <button
        class="btn-primary"
        [disabled]="!canProceed"
        (click)="goToConfirm()"
      >
        <span class="material-symbols-outlined">arrow_forward</span>
        Continuar
      </button>
    </div>

  </div>

  <!-- ═══ STEP 2: Confirmar datos ═══ -->
  <div *ngIf="step === 'confirm'" class="pub-content animate-fade-in">

    <!-- Resumen selección -->
    <div class="summary-card stagger-1">
      <div class="summary-row">
        <span class="material-symbols-outlined">medical_services</span>
        <div>
          <span class="summary-label">Servicio</span>
          <span class="summary-value">{{ selectedService.label }}</span>
        </div>
      </div>
      <div class="summary-row">
        <span class="material-symbols-outlined">event</span>
        <div>
          <span class="summary-label">Fecha</span>
          <span class="summary-value">{{ formatDateFull(selectedDate) }}</span>
        </div>
      </div>
      <div class="summary-row">
        <span class="material-symbols-outlined">schedule</span>
        <div>
          <span class="summary-label">Hora</span>
          <span class="summary-value">{{ selectedTime }} hs</span>
        </div>
      </div>
    </div>

    <!-- Formulario del cliente -->
    <section class="pub-section stagger-2">
      <h2 class="pub-section__label">
        <span class="material-symbols-outlined">person</span>
        Tus datos
      </h2>
      <div class="form-grid">
        <div class="form-field">
          <label class="form-label">Nombre completo *</label>
          <input
            class="input-field"
            type="text"
            placeholder="Ej: María García"
            [(ngModel)]="clientName"
            autocomplete="name"
          />
        </div>
        <div class="form-field">
          <label class="form-label">Email *</label>
          <input
            class="input-field"
            type="email"
            placeholder="Ej: maria@email.com"
            [(ngModel)]="clientEmail"
            autocomplete="email"
          />
        </div>
        <div class="form-field form-field--full">
          <label class="form-label">Notas <span class="form-label__optional">(opcional)</span></label>
          <textarea
            class="input-field notes-field"
            rows="3"
            placeholder="Describí brevemente el motivo de tu consulta..."
            [(ngModel)]="notes"
          ></textarea>
        </div>
      </div>
    </section>

    <div *ngIf="error" class="booking-error stagger-3">
      <span class="material-symbols-outlined">error</span>
      {{ error }}
    </div>

    <div class="pub-cta stagger-3">
      <button class="btn-secondary" (click)="backToSelect()">
        <span class="material-symbols-outlined">arrow_back</span>
        Volver
      </button>
      <button
        class="btn-primary"
        [disabled]="!canSubmit"
        (click)="submit()"
      >
        <span *ngIf="!isLoading">
          <span class="material-symbols-outlined">check_circle</span>
          Confirmar reserva
        </span>
        <span *ngIf="isLoading" class="spinner"></span>
      </button>
    </div>

  </div>

  <!-- ═══ STEP 3: Éxito ═══ -->
  <div *ngIf="step === 'success' && createdAppointment" class="pub-success animate-fade-in">
    <div class="success-icon">
      <span class="material-symbols-outlined">check_circle</span>
    </div>
    <h2>¡Reserva enviada!</h2>
    <p>
      Tu turno fue registrado. Recibirás confirmación en
      <strong>{{ createdAppointment.clientEmail }}</strong> cuando el profesional lo apruebe.
    </p>

    <div class="success-details">
      <div class="success-row">
        <span class="material-symbols-outlined">medical_services</span>
        <span>{{ createdAppointment.serviceType }}</span>
      </div>
      <div class="success-row">
        <span class="material-symbols-outlined">event</span>
        <span>{{ formatDateFull(createdAppointment.date) }}</span>
      </div>
      <div class="success-row">
        <span class="material-symbols-outlined">schedule</span>
        <span>{{ createdAppointment.time }} hs · {{ createdAppointment.duration }} min</span>
      </div>
    </div>

    <button class="btn-secondary" (click)="step = 'select'">
      Reservar otro turno
    </button>
  </div>

</div>
